import React from 'react'
import PropTypes from 'prop-types'

import List from 'material-ui/List'
import ChatMessageMemberListItem from './ChatMessageMemberListItem'
import ChatRoomAddOperation from './ChatRoomAddOperation'
import MessagesUtils from '../infra/MessagesUtils'
import Analytics from 'infra/analytics/Analytics'

import { connect } from 'react-redux'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'

class ChatRoomMembers extends React.Component {

  static propTypes = {
    userId: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      userId: props.userId,
      userInfo: {},
      teamInfo: {},
      roomId: '',
      currentText: '',
      removeUserIdInfo: '',
      openDialog: false,
      loadingRemove: false
    }
    this.dialogCallbackRemove = this.dialogCallbackRemove.bind(this)
    this.dialogCallbackCancel = this.dialogCallbackCancel.bind(this)
    this.handleDialog = this.handleDialog.bind(this)
  }

  dialogCallbackCancel() {
    this.setState({openDialog: false})
  }

  dialogCallbackRemove() {
    this.setState({loadingRemove: true})

    MessagesUtils
      .removeMembersFromRoom({ title: this.props.roomTitle, id : this.props.roomId },
        { id: this.props.teamId },
        [{ userId: this.state.removeUserIdInfo }])
      .then(() => {
        this.setState({openDialog: false, loadingRemove: false})
        Analytics.track(Analytics.ROOM_MEMBERS_REMOVED)
      })
      .catch((err) => {
        this.setState({openDialog: false, loadingRemove: false})
      })
  }

  handleDialog(removeUserIdInfo) {
    this.setState({openDialog: true, removeUserIdInfo: removeUserIdInfo})
  }

  isLoading() {
    return !this.props.members
        || !this.props.teamMembers
  }

  renderMembers(){
    const members = this.props.members
    const membersRendered = []

    for (let id in members){
      if (members.hasOwnProperty(id)){

        const member = members[id]
        //TODO Create Fibo Avatar component that handles color. TeamInfo.members is not required here
        const teamMember = this.props.teamMembers.find((memberTeam) => memberTeam.userId === member.userId)
        const color = teamMember ? teamMember.color : ''
        const role = teamMember ? teamMember.role : ''
        member.role = role
        membersRendered.push(
          <ChatMessageMemberListItem
            key={id}
            member={member}
            color={color}
            currentRoomId={this.props.roomId}
            openDialog={this.handleDialog}
          />
        )
      }
    }
    return membersRendered
  }

  render() {
    let title = ""
    let memberComponents = []
    const actions=[]

    if (!this.isLoading()){
      const membersNo = Object.keys(this.props.members).length
      title = `Members (${membersNo})`

      memberComponents = this.renderMembers()
    }

    if (!this.state.loadingRemove){
      actions.push(
        <FlatButton
          label="Cancel"
          primary={true}
          onTouchTap={this.dialogCallbackCancel}
        />
      )
      actions.push(
        <FlatButton
          label="Remove"
          primary={true}
          onTouchTap={this.dialogCallbackRemove}
        />
      )
    }

    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection:'column',
        }}>
        <div
          style={{
            height: 48, //-2 to take pixel difference into account
            flexShrink:0,
            backgroundColor:'#F7F7F7',
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: '#D3D3D3',
          }}>
          <span
            style={{
              display:'flex',
              fontSize: 16,
              color:'#757575'
            }}>
            {title}
          </span>

        </div>

        <div
          style={{
            display: 'flex',
            overflow: 'auto',
          }}>
          {
            !this.isLoading()
            &&
            <List
              style={{
                width: '100%'
              }}>
              {
                this.props.roomType != "team_random"
                &&
                this.props.roomType != "team_general"
                &&
                <ChatRoomAddOperation
                  operation="AddMember"
                  currentMembers={this.props.members}
                  currentRoomId={this.props.roomId} />
              }
              {memberComponents}
              <Dialog
                actions={actions}
                modal={false}
                open={this.state.openDialog}
                contentStyle={{maxWidth: 310}}
                title={'Remove User From Room?'}
                onRequestClose={this.dialogCallbackCancel}>
                {
                  this.state.loadingRemove
                    ? <CircularProgress size={60} thickness={7} color='#527da3' style={{margin: '60px'}}/>
                    : "User will no longer have access to this room"
                }
              </Dialog>
            </List>
          }
        </div>
        <br/>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const roomId = ownProps.roomId
  const currentRoom = state.firebase.rooms.metadata[ownProps.roomId]
  let members = undefined
  let roomTitle = undefined
  let roomType = undefined

  // Get members for a particular roomId from props
  if (state.firebase.rooms.members) {
    const roomMembers = state.firebase.rooms.members[roomId]
    if (roomMembers && !roomMembers.loading) {
      members = roomMembers.value
    }
  }
  if (currentRoom) {
    roomTitle = currentRoom.value.title
  }
  if (state.firebase.rooms.metadata[roomId]) {
    roomType = state.firebase.rooms.metadata[roomId].value.type
  }

  return {
    members: members,
    teamMembers: state.firebase.team.members.value,
    roomTitle: roomTitle,
    teamId: state.firebase.team.metadata.value.id,
    userId: state.firebase.userAuth.id,
    roomType: roomType
  }
}

export default connect(mapStateToProps)(ChatRoomMembers)



// WEBPACK FOOTER //
// ./src/chat/ChatRoomMembers.js